import script from "./work-order-section.vue?vue&type=script&setup=true&lang=ts"
export * from "./work-order-section.vue?vue&type=script&setup=true&lang=ts"

import "./work-order-section.vue?vue&type=style&index=0&id=543a4a5b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-543a4a5b"]])

export default __exports__